import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import "../index.css"
import { Subitle } from "./style";
import CardTentangPerusahaan from '../../components/CardTentangPerusahaan';
import Card2 from "../../components/Card2";
import { Button, Stack, SimpleGrid, Box, Text, Container, Center, VStack } from "@chakra-ui/react";
import Footer from "../../components/Footer";
import Navigation from "../../components/Navbar";
import ReactLoading from "react-loading";
import "./static/css/index.css";
import APIConfig from "../../api/APIConfig";
import AuthService from "../../services/auth.service";
import swal from 'sweetalert';

function recruitmentTime(string){
    return new Date(string).getMonth();
}


function publishDay(string){
    return new Date(string).getDate();
}

function sektorHandler(Integer){
    if(Integer === 0) return "Technology";
    else if(Integer === 1) return "BUMN";
    else if(Integer === 2) return "Healthcare and Hospitality";
    else if(Integer === 3) return "Multilaterals and Non-profits";
    else if(Integer === 4) return "Professional Services";
    else return "Others";
}

function ukuranHandler(Integer){
    if(Integer === 0) return "1-10";
    else if(Integer === 1) return "11-50";
    else if(Integer === 2) return "51-100";
    else if(Integer === 3) return "101-500";
    else if(Integer === 4) return "501-1000";
    else if(Integer === 5) return "1001-5000";
    else if(Integer === 6) return "5001-10000";
    else return "+10000";
}

const DetailLowonganPage = (props) => {
    const navigate = useNavigate();
    const [waktuDipublish, setWaktuDipublish] = useState("");
    const [tanggalSelesai, setTanggalSelesai] = useState("");
    const [proposal, setProposal] = useState([]);
    const [mitra, setMitra] = useState([]);
    const [lowongan, setLowongan] = useState();
    const [isLowonganTersimpan, setIsLowonganTersimpan] = useState(false);
    const [currentUser, setCurrentUser] = useState([]);
    const [validation, setValidation] = useState({});

    const [spinner, setSpinner] = useState(false); 

    let d = new Date().getDate();
    console.log(d)
    console.log(tanggalSelesai)
    const { id } = useParams();
    const { idPeserta } = useParams();

    const simpanLowongan = async(e) => {
        e.preventDefault();
        swal({
            title: "Anda ingin simpan lowongan ini?",
            buttons: {
                yes: {
                text: "Ya",
                value: "yes"
                },
                no: {
                text: "Tidak",
                value: "no"
                }
            }
        })
        .then((value) => {
            if (value === "yes") {
                    APIConfig.post(`v1/lowongan-tersimpan`, {
                        lowongan: lowongan,
                        peserta: currentUser.peserta[0]
                    })
                    .then(() => {
                        swal({
                            title: "Anda berhasil menyimpan lowongan ini",
                            icon: "success",
                            button: "OK",
                        }); 
                        console.log("berhasil")
                        navigate(`/peserta/item-tersimpan/${currentUser.peserta[0].idPeserta}`);
            
                    })
                    .catch((error) => {
                        console.log(error);

                        setValidation(error.response.data);
        
                        console.log(error.response.data);
                        let resMessage;
            
                        resMessage = error.response.data;
            
                        if(resMessage.includes("Anda sudah menyimpan lowongan ini")) {
                            swal({
                                title: "Anda sudah pernah menyimpan lowongan ini",
                                icon: "error",
                                buttons: {
                                    yes: {
                                    text: "Lihat",
                                    value: "yes"
                                    },
                                    no: {
                                    text: "OK",
                                    value: "no"
                                    }
                                }
                            })
                            .then((value) => {
                                if (value === "yes") {
                                    navigate(`/peserta/item-tersimpan/${currentUser.peserta[0].idPeserta}`)
                                } 
                                return false;
                            });   
                        }
                    }) 
            }
            return false;
        });
    }

    const hapusLowongan = async(e) => {
        e.preventDefault();
        swal({
            title: "Anda ingin hapus lowongan ini?",
            buttons: {
                yes: {
                text: "Ya",
                value: "yes"
                },
                no: {
                text: "Tidak",
                value: "no"
                }
            }
        })
        .then((value) => {
            if (value === "yes") {
                APIConfig.post(`v1/hapus-lowongan-tersimpan`, {
                    idLowongan: id,
                    idPeserta: currentUser.peserta[0].idPeserta
                })
                .then(() => {
                    swal({
                        title: "Anda berhasil menghapus lowongan ini dari item tersimpan",
                        icon: "success",
                        button: "OK",
                    }); 
                    console.log("berhasil")
                    navigate(`/peserta/item-tersimpan/${currentUser.peserta[0].idPeserta}`);
        
                })
                .catch((error) => {
                    console.log(error);
                    setValidation(error.response.data);
    
                    console.log(error.response.data);
                    let resMessage;
        
                    resMessage = error.response.data;
        
                    if(resMessage.includes("Anda sudah menyimpan lowongan ini")) {
                        swal({
                            title: "Anda sudah pernah menyimpan lowongan ini",
                            icon: "error",
                            buttons: {
                                yes: {
                                text: "Lihat",
                                value: "yes"
                                },
                                no: {
                                text: "OK",
                                value: "no"
                                }
                            }
                        })
                        .then((value) => {
                            if (value === "yes") {
                                navigate(`/peserta/item-tersimpan/${currentUser.peserta[0].idPeserta}`)
                            } 
                            return false;
                        });   
                    }
                }) 
            }
            return false;
        });
    }

    useEffect(() => {
        const user = AuthService.getCurrentUser();

        if(user) {
            setCurrentUser(user);
        }
    }, []);


    const getLowongan = async() => {
        setSpinner(true);

        const response = await APIConfig.get(`/v1/lowongan/${id}`);
        const result = await response.data;
        console.log(result)
        setLowongan(result);
        setWaktuDipublish(result.waktuDipublish);
        setTanggalSelesai(new Date(result.proposal.tanggalSelesai));
        setProposal(result.proposal);
        setMitra(result.mitra);

        const response2 = await APIConfig.get(`/v1/list-lowongan-tersimpan-peserta/${idPeserta}`);
        const result2 = await response2.data;
        result2.map((data) => (data.lowongan.idLowongan===id ? setIsLowonganTersimpan(true) : null))

        setSpinner(false);
    };

    useEffect(() => {
        getLowongan();
    }, []);

    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>  
        )
    }

    return (
        <>
        <Navigation />
            <div>
                <Container margin={'0'} padding={'0'} maxW={'100%'}>
                    <Stack className="grid2" fontFamily={'Inter'}>
                        <Card2 
                            jabatan={proposal.namaPosisi}
                            perusahaan={mitra.namaResmi}
                            durasi={`${recruitmentTime(proposal.tanggalSelesai) - recruitmentTime(proposal.tanggalMulai)} bulan`}
                            lokasi={proposal.lokasi}
                            waktuPost={`${d - publishDay(waktuDipublish)}`}
                            logo={mitra.image}
                            nominal={proposal.nominal}
                        /> 
                        <br></br>   
                        <Stack className="gridbutton"  padding={'0'} spacing={4} direction='row' align='center' fontFamily={'Inter'}>
                            <Link to={`/lowongan/lamar/${id}`} style={{textDecoration: 'none'}}>
                                <Button size='lg' style={{background: '#6554C0', color: '#FFFFFF'}}>Lamar</Button>
                            </Link>
                            <Link to="/lowongan" style={{textDecoration: 'none'}}>
                                {isLowonganTersimpan===false ? 
                                <Button
                                    size='lg' 
                                    onClick={simpanLowongan}
                                    style={{background: '#FFFFFF', color: '#6554C0', border: '2px solid #6554C0'}}>
                                Simpan
                                </Button> :
                                <Button 
                                    size='lg'
                                    onClick={hapusLowongan}
                                    style={{background: '#FFFFFF', color: '#6554C0', border: '2px solid #6554C0'}}>
                                Hapus
                                </Button>
                                }
                            </Link>
                        </Stack>
                    </Stack>
                </Container>
                <Container margin={'0'} padding={'0'}  maxW={'100%'}>
                    <Stack className="grid2" fontFamily={'Inter'}>
                        <Subitle>Deskripsi Kegiatan</Subitle>    
                        <br></br>  
                        <Text>{proposal.deskripsiPekerjaan}</Text>
                        <br></br><br></br>
                        <Subitle>Kriteria Pendaftar</Subitle>   
                        <br></br>   
                        <Text>{proposal.kriteriaPeserta}</Text>
                        <br></br><br></br>
                        <Subitle>Kemampuan Wajib</Subitle>  
                        <br></br>    
                        <Text>{proposal.kemampuanWajib}</Text> 
                        <br></br><br></br>
                        <Subitle>Informasi Tambahan</Subitle>
                        <br></br>      
                        <Text>{proposal.infoTambahan}</Text> 
                    </Stack>
                </Container>

                <Container margin={'0'} padding={'0'} maxW={'100%'}>
                    <Stack className="grid2" fontFamily={'Inter'}>
                    <Subitle>Tentang Perusahaan</Subitle>
                    <br></br>
                    <CardTentangPerusahaan 
                        namaBrand={mitra.namaBrand}
                        namaResmi={mitra.namaResmi}
                        lokasi={mitra.lokasiPusat}
                        negara="Indonesia"
                        sektorBisnis={`${sektorHandler(mitra.sektorBisnis)}`}
                        ukuranPerusahaan={`${ukuranHandler(mitra.sizeMitra)}`}
                        logo={mitra.image}
                    />    
                    <br></br>
                    <Stack p={6}>
                    <Link to={`/mitra/detail/${idPeserta}/${id}`} style={{textDecoration: 'none'}}>
                        <Button style={{background: '#FFFFFF', color: '#6554C0', border: '2px solid #6554C0'}}>
                            Lihat Profil Perusahaan
                        </Button>
                    </Link>
                    </Stack>
                    <br></br>    
                    <SimpleGrid 
                        className="grid3"
                        minChildWidth='240px' 
                        pt={6} 
                        columns={[3, null, 3]} 
                        spacing='40px' 
                        border={'1px solid #DADADA'} 
                        borderRadius={'5px'} 
                        padding={'50px'}>
                        <Box height='100%'>
                            <Text style={{color: '#828282'}}>Kantor Pusat</Text>
                            <Text>{mitra.lokasiPusat}</Text>
                        </Box>
                        <Box height='100%'>
                            <Text style={{color: '#828282'}}>Situs</Text>
                            <Text>{mitra.website}</Text>
                        </Box>
                        <Box height='100%'>
                            <Text style={{color: '#828282'}}>Alamat</Text>
                            <Text>{mitra.alamat}</Text>
                        </Box>
                        <Box height='100%'>
                            <Text style={{color: '#828282'}}>Industri</Text>
                            {mitra.kategori === 0 ? (
                                        <Text>Startup</Text> 
                                    ) : (
                                        mitra.kategori === 1 ? (
                                        <Text>Global Company</Text>
                                    ) : (
                                        mitra.kategori === 2 ? (
                                        <Text>Multilaterals Organizations</Text>
                                    ) : (
                                        mitra.kategori === 3 ? (
                                        <Text>Non-profits Organizations</Text>
                                    ) : (
                                        <Text>Hospitals</Text>
                                ))))}
                        </Box>
                        <Box height='100%'>
                            <Text style={{color: '#828282'}}>Ukuran Perusahaan</Text>
                            {mitra.sizeMitra === 0 ? (
                                        <Text>1-10</Text> 
                                    ) : (
                                        mitra.sizeMitra === 1 ? (
                                        <Text>11-50</Text>
                                    ) : (
                                        mitra.sizeMitra === 2 ? (
                                        <Text>51-100</Text>
                                    ) : (
                                        mitra.sizeMitra === 3 ? (
                                        <Text>100-500</Text>
                                    ) : (
                                        mitra.sizeMitra === 4 ? (
                                            <Text>501-1000</Text>
                                    ) : (
                                        mitra.sizeMitra === 5 ? (
                                            <Text>1001-5000</Text>
                                    ) : (
                                        mitra.sizeMitra === 6 ? (
                                        <Text>5001-10000</Text>
                                    ) : (
                                        <Text>+10000</Text>
                                )))))))}
                        </Box>
                        <Box height='100%'>
                            <Text style={{color: '#828282'}}>Tahun Berdiri</Text>
                            <Text>{mitra.tahunBerdiri}</Text>
                        </Box>
                    </SimpleGrid>
                    </Stack>
                </Container>    
            </div>
        <Footer />
        </>
    );
}

export default DetailLowonganPage;